import React, {useCallback} from 'react';

import {Table, Text} from '@phonectas/unifon-ui-kit';
import {useTranslation} from 'react-i18next';
import {InvoiceLine} from 'common/types/store/threeSixtyTypes';
import {convertToKroner} from 'utils/number';

interface VismaTooltipContentProps extends React.HTMLAttributes<HTMLDivElement> {
    data: InvoiceLine | InvoiceLine[];
}

const VismaTooltipContent: React.FC<VismaTooltipContentProps> = ({data, ...props}) => {
	const [t] = useTranslation();

	// Ensure data is always treated as an array
	const items = Array.isArray(data) ? data : [data];

	const renderItem = useCallback((item: InvoiceLine, index: number) => (
		<Table.Row
			key={index}
			index={index}
			style={{padding: '0px'}}
		>
			<Table.Cell>
				{convertToKroner(item?.AmountVat)}
			</Table.Cell>
			<Table.Cell>
				{convertToKroner(item?.AmountGross)}
			</Table.Cell>
		</Table.Row>
	), []);

	if (!data || items.length === 0) return null;

	return (
		<div
			{...props}
			style={{
				width: '100%',
				minWidth: '120px',
				height: 'auto',
			}}
		>
			<Table
				variant="compact"
				items={items}
				fullWidth
				renderItem={(item, index) => renderItem(item, index)}
			>
				<Table.Row style={{padding: '0px'}}>
					<Table.Cell><Text color="secondary">{t('VAT')}</Text></Table.Cell>
					<Table.Cell><Text color="secondary">{t('Inc VAT')}</Text></Table.Cell>
				</Table.Row>
			</Table>
		</div>
	);
}

export default React.memo(VismaTooltipContent);
